<template>
  <vs-popup id="post-select-popup" :title="title" :active.sync="showPopup">
    <div v-if="loading" style="text-align: center; padding: 20px;">불러오는 중...</div>
    <div v-else style="overflow-x: auto;">
      <table>
        <thead>
          <tr>
            <th style="width: 60px;">No.</th>
            <th v-for="head in heads" :key="head.name">{{ head.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(post, i) in boardList" :key="post.id" @click="onClickPost(post)">
            <td>{{ post.id }}</td>
            <td v-for="(head, headI) in heads" :key="head.name">{{ getColData(headI, post) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import singlePageList from "@/views/boards/single-page/listIndex";
import moment from "moment";

export default {
  name: "PopupPostSelect",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "게시글 목록" },
    boardId: { type: Number, default: null },
    postIds: { type: Array, default: function() { return []; } },
  },
  data() {
    return {
      showPopup: this.value,
      boardList: [],
      loading: false,
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    listFileData() {
      if (!this.boardId) return null;
      return singlePageList[this.boardId + "_list"];
    },
    heads() {
      if (!this.listFileData) return [];
      return this.listFileData.getHead();
    },
  },
  watch: {
    value: {
      handler(value) {
        this.showPopup = value;
        if (value) {
          this.loadBoardList();
        }
      },
    },
    showPopup(value) {
      this.$emit("input", value);
    },
  },
  methods: {
    async loadBoardList() {
      if (!this.showPopup || !this.boardId) return;
      this.loading = true;
      this.boardList = [];

      try {
        var response = await HttpRequest.get("/api/v1/board/post/" + this.boardId, {
          params: {
            projectId: this.projectId,
            page: 1,
            perPage: 100,
            orderTarget: "created_at",
            orderDirection: "desc",
            postIds: this.postIds.length > 0 ? this.postIds : undefined,
          },
        });
        this.boardList = response.data || [];
      } catch (e) {
        this.boardList = [];
      } finally {
        this.loading = false;
      }
    },

    onClickPost(post) {
      this.showPopup = false;
      this.$emit("select", { id: post.id, boardId: this.boardId });
    },

    getColData(index, data) {
      if (!this.listFileData) return "";
      try {
        return this.listFileData.getCol(index, data, {
          getContent: this.getContent,
          getCreatedDate: this.getCreatedDate,
          getCompanyName: function() { return ""; },
          getContentTargetList: function(list) { return list ? list.map(function(d) { return d.target; }).join(", ") : ""; },
          getContentRiskList: function(list) {
            if (!list) return "";
            var result = list.map(function(d) { return d.input_3; }).join(", ");
            return result.length > 19 ? result.substring(0, 19) + "..." : result;
          },
          getContentStringList: function(list) { return list ? list.join(", ") : ""; },
          onNameBlur: function(name) { return name; },
          comma: function(str) { return ("" + str).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","); },
        });
      } catch (e) {
        return "";
      }
    },

    getContent(data) {
      if (data.post_content) {
        return JSON.parse(data.post_content).body;
      }
      return {};
    },

    getCreatedDate(data) {
      if (!data) return "";
      return moment(data).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
#post-select-popup::v-deep {
  .vs-popup {
    width: 90% !important;
    @media print, screen and (min-width: theme("screens.xl")) {
      width: 70% !important;
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f8f8f8;

  th,
  td {
    text-align: center;
    padding: 10px;
    transition: all 0.3s ease;
  }

  tr {
    cursor: pointer;

    &:nth-child(2n-1) {
      background-color: #f9f9f9;
    }

    &:hover td {
      background-color: #ededed;
    }
  }
}
</style>
